import React from 'react';
import ids from '../../../QestIds';
import { WorksheetRootComponent } from '../../../Core/types';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { DispersantSection, WashingSection, MassesSection } from './Sections';

const qestIds = [ids.wash.ASTM_D6913.rev2017];

let MeasuredWashAstmD6913Worksheet: WorksheetRootComponent = () => (
  <>
    <DispersantSection />
    <WashingSection />
    <MassesSection />
  </>
);

MeasuredWashAstmD6913Worksheet.qestIds = qestIds;
MeasuredWashAstmD6913Worksheet = withInjectedProps(MeasuredWashAstmD6913Worksheet);

export default MeasuredWashAstmD6913Worksheet;
export { MeasuredWashAstmD6913Worksheet };
